(function () {
  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const fixed = amount.toFixed(2);
    const parts = fixed.split(".");
    return "$" + parts[0] + "<sup>" + parts[1] + "</sup>";
  }

  class SavedItemsPage {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.storageKey =
        (window.savedItemsPageConfig && window.savedItemsPageConfig.storageKey) ||
        "productFavorites";

      this.container = root.querySelector(".saved-items-grid-" + this.sectionId);
      this.empty = root.querySelector(".saved-items-empty-" + this.sectionId);
      this.loading = root.querySelector(".saved-items-loading-" + this.sectionId);
      this.items = [];
      this.boundOutsideClick = this.handleOutsideClick.bind(this);
    }

    init() {
      if (!this.container || !this.empty || !this.loading) return;

      this.load();

      window.addEventListener("storage", (event) => {
        if (event.key === this.storageKey) {
          this.load();
        }
      });

      window.addEventListener("click", this.boundOutsideClick);
    }

    handleOutsideClick(event) {
      if (!this.root.contains(event.target)) {
        this.closeAllQuickAdd();
      }
    }

    getFavorites() {
      try {
        const saved = localStorage.getItem(this.storageKey);
        if (!saved) return [];
        const parsed = JSON.parse(saved);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error("Failed to read favorites:", e);
        return [];
      }
    }

    normalizeFavorites(rawItems) {
      return rawItems
        .map((item) => {
          if (typeof item === "object" && item !== null) {
            return {
              id: String(item.id || ""),
              handle: String(item.handle || "").trim(),
              url: String(item.url || "").trim(),
            };
          }

          return {
            id: String(item || ""),
            handle: "",
            url: "",
          };
        })
        .filter((item) => item.id || item.handle || item.url);
    }

    extractHandleFromUrl(url) {
      const value = String(url || "").trim();
      if (!value) return "";

      const match = value.match(/\/products\/([^?#/]+)/i);
      return match ? match[1].trim() : "";
    }

    getFetchHandle(savedItem) {
      if (savedItem.handle) return savedItem.handle;
      return this.extractHandleFromUrl(savedItem.url);
    }

    async load() {
      try {
        const favorites = this.normalizeFavorites(this.getFavorites());

        console.log("saved favorites raw:", this.getFavorites());
        console.log("saved favorites normalized:", favorites);

        this.container.innerHTML = "";
        this.loading.classList.remove("is-hidden");
        this.empty.classList.remove("is-visible");
        this.container.classList.add("is-hidden");

        if (!favorites.length) {
          this.loading.classList.add("is-hidden");
          this.empty.classList.add("is-visible");
          return;
        }

        const products = await Promise.all(
          favorites.map(async (item) => {
            const product = await this.fetchProduct(item);
            return product || null;
          })
        );

        this.items = products.filter(Boolean);

        console.log("saved items fetched products:", this.items);

        this.loading.classList.add("is-hidden");

        if (!this.items.length) {
          this.empty.classList.add("is-visible");
          return;
        }

        this.render();
        this.container.classList.remove("is-hidden");
      } catch (error) {
        console.error("Saved items load failed:", error);
        this.loading.classList.add("is-hidden");
        this.empty.classList.add("is-visible");
      }
    }

    async fetchProduct(savedItem) {
      const handle = this.getFetchHandle(savedItem);

      if (!handle) {
        console.warn("Missing handle and URL for saved item:", savedItem);
        return null;
      }

      const endpoint = "/products/" + handle + ".js";

      try {
        console.log("Fetching saved product:", endpoint, savedItem);

        const response = await fetch(endpoint, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        if (!response.ok) {
          console.warn("Saved product fetch failed:", endpoint, "status:", response.status);
          return null;
        }

        const product = await response.json();

        if (!product || !product.id) {
          console.warn("Saved product JSON invalid:", endpoint, product);
          return null;
        }

        return product;
      } catch (error) {
        console.error("Product fetch failed:", endpoint, error);
        return null;
      }
    }

    getOptionIndex(productOrCard, type) {
      if (productOrCard instanceof Element) {
        const raw =
          type === "size"
            ? productOrCard.dataset.sizeOptionIndex
            : productOrCard.dataset.colorOptionIndex;

        const index = parseInt(raw, 10);
        return Number.isNaN(index) ? -1 : index;
      }

      const names = productOrCard.options || [];

      return names.findIndex((name) => {
        const lower = String(name).toLowerCase().trim();

        if (type === "size") {
          return (
            lower === "size" ||
            lower.includes("size") ||
            lower.includes("waist") ||
            lower.includes("inseam") ||
            lower.includes("length") ||
            lower.includes("width")
          );
        }

        if (type === "color") {
          return (
            lower === "color" ||
            lower === "colour" ||
            lower.includes("color") ||
            lower.includes("colour")
          );
        }

        return false;
      });
    }

    getUniqueSizes(product, sizeIndex) {
      if (sizeIndex === -1) return [];
      const map = new Map();

      (product.variants || []).forEach((variant) => {
        const size = variant.options && variant.options[sizeIndex];
        if (!size) return;

        if (!map.has(size)) {
          map.set(size, { value: size, available: false });
        }

        if (variant.available) {
          map.get(size).available = true;
        }
      });

      return Array.from(map.values());
    }

    render() {
      const html = this.items
        .map((product) => {
          try {
            return this.renderCard(product);
          } catch (error) {
            console.error("renderCard failed:", error, product);
            return "";
          }
        })
        .join("");

      this.container.innerHTML = html;

      if (!html.trim()) {
        this.empty.classList.add("is-visible");
        return;
      }

      this.bindEvents();
    }

    renderCard(product) {
      const sizeIndex = this.getOptionIndex(product, "size");
      const hasSizes = sizeIndex !== -1;
      const isSoldOut = !product.available;

      const featuredImage =
        (typeof product.featured_image === "string" ? product.featured_image : "") ||
        (Array.isArray(product.images) && product.images.length ? product.images[0] : "");

      const productUrl = "/products/" + product.handle;

      const compareAt =
        Number(product.compare_at_price || 0) > Number(product.price || 0);

      const firstAvailableVariant =
        (product.variants || []).find((variant) => variant.available) ||
        (product.variants || [])[0] ||
        null;

      const sizeValues = this.getUniqueSizes(product, sizeIndex);

      const sizesHtml = hasSizes
        ? sizeValues
            .map((size) => {
              return `
                <button
                  type="button"
                  class="saved-items-size-pill-${this.sectionId}${size.available ? "" : " is-disabled"}"
                  data-size-value="${escapeHtml(size.value)}"
                  ${size.available ? "" : 'disabled aria-disabled="true"'}
                >
                  <span>${escapeHtml(size.value)}</span>
                </button>
              `;
            })
            .join("")
        : "";

      const variantsPayload = encodeURIComponent(
        JSON.stringify(
          (product.variants || []).map((variant) => ({
            id: variant.id,
            available: variant.available,
            options: variant.options || [],
          }))
        )
      );

      return `
        <div
          class="saved-items-card-${this.sectionId}${isSoldOut ? " is-sold-out" : ""}"
          data-product-id="${escapeHtml(product.id)}"
          data-product-handle="${escapeHtml(product.handle)}"
          data-product-url="${escapeHtml(productUrl)}"
          data-size-option-index="${sizeIndex}"
          data-color-option-index="-1"
        >
          <div class="saved-items-image-wrap-${this.sectionId}">
            <a href="${productUrl}" class="saved-items-card-link-${this.sectionId}">
              ${
                featuredImage
                  ? `<img class="saved-items-image-${this.sectionId}" src="${escapeHtml(
                      featuredImage
                    )}" alt="${escapeHtml(product.title)}" loading="lazy">`
                  : ""
              }
            </a>

            ${
              compareAt
                ? `<div class="saved-items-sale-badge-${this.sectionId}">SALE</div>`
                : ""
            }

            <div class="saved-items-quick-add-wrap-${this.sectionId}">
              ${
                isSoldOut
                  ? `<div class="saved-items-soldout-state-${this.sectionId}">Sold out</div>`
                  : `
                    <button
                      type="button"
                      class="saved-items-quick-add-${this.sectionId}"
                      data-has-sizes="${hasSizes ? "true" : "false"}"
                      data-variant-id="${firstAvailableVariant ? escapeHtml(firstAvailableVariant.id) : ""}"
                    >
                      Quick add to cart
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M10.6667 10.6667C11.0203 10.6667 11.3594 10.8071 11.6095 11.0572C11.8595 11.3072 12 11.6464 12 12C12 12.3536 11.8595 12.6928 11.6095 12.9428C11.3594 13.1929 11.0203 13.3333 10.6667 13.3333C10.313 13.3333 9.97391 13.1929 9.72386 12.9428C9.47381 12.6928 9.33333 12.3536 9.33333 12C9.33333 11.26 9.92667 10.6667 10.6667 10.6667ZM0 0H2.18L2.80667 1.33333H12.6667C12.8435 1.33333 13.013 1.40357 13.1381 1.5286C13.2631 1.65362 13.3333 1.82319 13.3333 2C13.3333 2.11333 13.3 2.22667 13.2533 2.33333L10.8667 6.64667C10.64 7.05333 10.2 7.33333 9.7 7.33333H4.73333L4.13333 8.42L4.11333 8.5C4.11333 8.5442 4.13089 8.5866 4.16215 8.61785C4.19341 8.64911 4.2358 8.66667 4.28 8.66667H12V10H4C3.64638 10 3.30724 9.85952 3.05719 9.60948C2.80714 9.35943 2.66667 9.02029 2.66667 8.66667C2.66667 8.43333 2.72667 8.21333 2.82667 8.02667L3.73333 6.39333L1.33333 1.33333H0V0ZM4 10.6667C4.35362 10.6667 4.69276 10.8071 4.94281 11.0572C5.19286 11.3072 5.33333 11.6464 5.33333 12C5.33333 12.3536 5.19286 12.6928 4.94281 12.9428C4.69276 13.1929 4.35362 13.3333 4 13.3333C3.64638 13.3333 3.30724 13.1929 3.05719 12.9428C2.80714 12.6928 2.66667 12.3536 2.66667 12C2.66667 11.26 3.26 10.6667 4 10.6667ZM10 6L11.8533 2.66667H3.42667L5 6H10Z" fill="black"/>
                      </svg>
                    </button>

                    <div class="saved-items-added-state-${this.sectionId}">Added</div>

                    <div class="saved-items-size-selector-${this.sectionId}">
                      <div class="saved-items-size-list-${this.sectionId}">
                        ${sizesHtml}
                      </div>

                      <button
                        type="button"
                        class="saved-items-size-close-${this.sectionId}"
                        aria-label="Close size selector"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                      </button>
                    </div>
                  `
              }
            </div>

            <div
              class="saved-items-variants-data-${this.sectionId}"
              data-variants="${variantsPayload}"
              hidden
            ></div>
          </div>

          <div class="saved-items-info-${this.sectionId}">
            <div class="saved-items-copy-${this.sectionId}">
              ${
                product.vendor
                  ? `<p class="saved-items-vendor-${this.sectionId}">${escapeHtml(product.vendor)}</p>`
                  : ""
              }

              <h3 class="saved-items-name-${this.sectionId}">${escapeHtml(product.title || "")}</h3>

              <div class="saved-items-price-row-${this.sectionId}">
                ${
                  compareAt
                    ? `
                      <span class="saved-items-compare-${this.sectionId}">${formatMoney(product.compare_at_price)}</span>
                      <span class="saved-items-sale-price-${this.sectionId}">${formatMoney(product.price)}</span>
                    `
                    : `
                      <span class="saved-items-price-${this.sectionId}">${formatMoney(product.price)}</span>
                    `
                }
              </div>
            </div>

            <button
              class="saved-items-fav-${this.sectionId}"
              type="button"
              data-remove-id="${escapeHtml(product.id)}"
              aria-label="Remove from saved items"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15.75C9 15.75 1.5 11.25 1.5 5.625C1.5 4.63044 1.89509 3.67661 2.59835 2.97335C3.30161 2.27009 4.25544 1.875 5.25 1.875C6.825 1.875 8.1 2.7 9 3.9375C9.9 2.7 11.175 1.875 12.75 1.875C13.7446 1.875 14.6984 2.27009 15.4017 2.97335C16.1049 3.67661 16.5 4.63044 16.5 5.625C16.5 11.25 9 15.75 9 15.75Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <a href="${productUrl}" class="saved-items-view-${this.sectionId}">
              View
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>
        </div>
      `;
    }

    bindEvents() {
      this.container.querySelectorAll(".saved-items-fav-" + this.sectionId).forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.removeFavorite(button.dataset.removeId);
        });
      });

      this.container
        .querySelectorAll(".saved-items-quick-add-" + this.sectionId)
        .forEach((button) => {
          button.addEventListener("click", async (event) => {
            event.preventDefault();
            event.stopPropagation();

            const card = button.closest(".saved-items-card-" + this.sectionId);
            const hasSizes = button.dataset.hasSizes === "true";

            if (card.classList.contains("is-added") || card.classList.contains("is-sold-out")) {
              return;
            }

            this.updateQuickAddState(card);

            if (!hasSizes) {
              const variantId = this.getSingleVariantId(card);
              if (!variantId) return;

              const success = await this.addToCart(variantId);
              if (success) this.showAddedState(card);
              return;
            }

            this.closeAllQuickAdd(card);
            card.classList.add("quick-add-open");
          });
        });

      this.container
        .querySelectorAll(".saved-items-size-close-" + this.sectionId)
        .forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            const card = button.closest(".saved-items-card-" + this.sectionId);
            card.classList.remove("quick-add-open");
          });
        });

      this.container
        .querySelectorAll(".saved-items-size-pill-" + this.sectionId)
        .forEach((button) => {
          button.addEventListener("click", async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (button.disabled || button.classList.contains("is-disabled")) {
              return;
            }

            const card = button.closest(".saved-items-card-" + this.sectionId);
            const sizeValue = button.dataset.sizeValue || "";
            const variant = this.findMatchingVariant(card, sizeValue);

            if (!variant || !variant.id) return;

            const success = await this.addToCart(String(variant.id));
            if (success) {
              card.classList.remove("quick-add-open");
              this.showAddedState(card);
            }
          });
        });

      this.container.querySelectorAll(".saved-items-card-" + this.sectionId).forEach((card) => {
        if (!window.matchMedia("(max-width: 749px)").matches) {
          card.addEventListener("mouseleave", () => {
            card.classList.remove("quick-add-open");
          });
        }
      });
    }

    getVariantData(card) {
      const el = card.querySelector(".saved-items-variants-data-" + this.sectionId);
      if (!el) return [];

      try {
        return JSON.parse(decodeURIComponent(el.dataset.variants || "[]"));
      } catch (error) {
        return [];
      }
    }

    getSingleVariantId(card) {
      const variants = this.getVariantData(card);
      const variant = variants.find((item) => item.available) || variants[0];
      return variant ? String(variant.id) : "";
    }

    findMatchingVariant(card, sizeValue) {
      const variants = this.getVariantData(card);
      const sizeIndex = this.getOptionIndex(card, "size");

      if (sizeIndex === -1) return null;

      return (
        variants.find((item) => {
          return item.available && item.options && item.options[sizeIndex] === sizeValue;
        }) || null
      );
    }

    updateQuickAddState(card) {
      const quickAddButton = card.querySelector(".saved-items-quick-add-" + this.sectionId);
      const sizeButtons = card.querySelectorAll(".saved-items-size-pill-" + this.sectionId);
      const hasSizes = quickAddButton && quickAddButton.dataset.hasSizes === "true";

      if (!quickAddButton || card.classList.contains("is-sold-out")) return;

      if (!hasSizes) {
        quickAddButton.dataset.variantId = this.getSingleVariantId(card) || "";
        return;
      }

      sizeButtons.forEach((button) => {
        const sizeValue = button.dataset.sizeValue || "";
        const variant = this.findMatchingVariant(card, sizeValue);

        if (variant && variant.id) {
          button.disabled = false;
          button.classList.remove("is-disabled");
        } else {
          button.disabled = true;
          button.classList.add("is-disabled");
        }
      });
    }

    async addToCart(variantId) {
      try {
        if (!variantId) return false;

        const formData = new FormData();
        formData.append("id", String(variantId));
        formData.append("quantity", "1");

        const response = await fetch(
          window.Shopify && Shopify.routes && Shopify.routes.root
            ? `${Shopify.routes.root}cart/add.js`
            : "/cart/add.js",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            credentials: "same-origin",
            body: formData
          }
        );

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || "Cart add failed");
        }

        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:add", { detail: { variantId } }));

        return true;
      } catch (error) {
        console.error("addToCart error:", error);
        return false;
      }
    }

    showAddedState(card) {
      card.classList.remove("quick-add-open");
      card.classList.add("is-added");

      window.clearTimeout(card._savedItemsTimeout);
      card._savedItemsTimeout = window.setTimeout(() => {
        card.classList.remove("is-added");
      }, 1200);
    }

    closeAllQuickAdd(exceptCard = null) {
      this.container
        .querySelectorAll(".saved-items-card-" + this.sectionId + ".quick-add-open")
        .forEach((card) => {
          if (exceptCard && exceptCard === card) return;
          card.classList.remove("quick-add-open");
        });
    }

    removeFavorite(productId) {
      const raw = this.getFavorites();
      const filtered = raw.filter((item) => {
        if (typeof item === "object" && item !== null) {
          return String(item.id) !== String(productId);
        }
        return String(item) !== String(productId);
      });

      localStorage.setItem(this.storageKey, JSON.stringify(filtered));
      this.load();
    }
  }

  function initSavedItemsPage() {
    const root = document.querySelector("[data-saved-items-root]");
    if (!root) return;

    const instance = new SavedItemsPage(root);
    instance.init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSavedItemsPage);
  } else {
    initSavedItemsPage();
  }
})();